/**
 * New unique IDs for characters. Uses the platform generator when available and
 * falls back to a random string, so the app never fails to create a crawler.
 */
export function newId(): string {
  const c = globalThis.crypto as Crypto | undefined;
  if (c && typeof c.randomUUID === 'function') return c.randomUUID();
  return 'id-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
}
